module.exports = __webpack_public_path__ + "static/media/striped_bar_prewash10.34faaacb.svg";